import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7344a8b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "heading-one-block" };
const _hoisted_2 = {
    class: "container text-center",
    "simply-fade": "fade"
};
const _hoisted_3 = ["innerHTML"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'heading_one_block',
    props: {
        d: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", {
                        innerHTML: _ctx.d.title
                    }, null, 8, _hoisted_3)
                ])
            ]));
        };
    }
});
